import { Helmet } from 'react-helmet';

const MetaData = ({ title, description, canonicalUrl }) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
  </Helmet>
);

export default MetaData;
